/* Timbrica — Flight Tracker
 *
 * Live ADS-B map: the shared basemap (js/map-tiles.js — OpenFreeMap vector;
 * RU users go through the same-origin /cdn/ofm proxy) with aircraft drawn on a
 * single canvas overlay. Positions, routes, photos, logos, traces all come
 * through our same-origin /api/flights/* proxies (cached) so RU users behind
 * external blocks get everything. Between server updates each plane is
 * dead-reckoned along its track so motion stays smooth. Plain ES5-ish module,
 * loaded after Leaflet.
 */
(function () {
    'use strict';

    var CFG = window.FLIGHT_CFG || {};
    var T = CFG.t || {};
    function tr(k, d) { return (T[k] != null && T[k] !== '') ? T[k] : (d != null ? d : k); }
    function toast(msg, type) { try { if (typeof window.__toast === 'function') window.__toast(msg, type || 'info'); } catch (e) {} }
    function ae(type, payload) { try { if (typeof window.__ae === 'function') window.__ae(type, Object.assign({ slug: 'flight-tracker' }, payload || {})); } catch (e) {} }
    var converted = false;
    function complete(f) { if (!converted) { converted = true; ae('tool_complete', { f: f }); } else { ae('feature_use', { f: f }); } }

    var POLL_MS = 10000, MIN_FETCH_GAP = 1800, DROP_AFTER = 70000, HIT_PX = 15;
    var EMERG = { '7500': 1, '7600': 1, '7700': 1 };

    function fmt(s, vars) { return String(s).replace(/:(\w+)/g, function (m, k) { return (vars && vars[k] != null) ? vars[k] : m; }); }
    function esc(s) { return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

    function boot() {
        if (!window.L || !document.getElementById('ftMap')) { return; }
        var L = window.L;

        var stage = document.getElementById('ftStage');
        var canvas = document.getElementById('ftPlanes');
        var ctx = canvas.getContext('2d');
        var loadingEl = document.getElementById('ftLoading');
        var dotEl = document.getElementById('ftDot');
        var statusText = document.getElementById('ftStatusText');
        var hintEl = document.getElementById('ftHint');
        var tipEl = document.getElementById('ftTip');
        var cardEl = document.getElementById('ftCard');
        var groundChk = document.getElementById('ftGround');
        var statsEl = document.getElementById('ftStats');
        var watchEl = document.getElementById('ftWatch');

        var dark = document.documentElement.dataset.theme !== 'light';
        var home = CFG.home || { lat: 51.3, lon: 0.05, z: 7 };

        var map = L.map('ftMap', {
            zoomControl: true, attributionControl: true, worldCopyJump: true,
            minZoom: 3, maxZoom: 12, preferCanvas: true
        }).setView([home.lat, home.lon], home.z);

        var credit = 'ADS-B: adsb.lol / adsb.fi / airplanes.live';

        /* Подложка через общий примитив: у неё есть ВТОРОЙ адрес и растровый
           запасной путь. Своё предупреждение тул сохраняет — оно точнее
           общего, потому что называет, что именно продолжает работать.
           ⚠️ Важная разница со старым поведением: раньше предупреждение
           вылезало на 6-й неудачной плитке, то есть ПОКА запасной адрес ещё
           даже не пробовали. Теперь оно появляется, когда не ответил НИ ОДИН
           адрес, — а до тех пор человек просто видит карту. */
        function tilesGone() {
            var msg = tr('map_offline', 'Map tiles unavailable — showing aircraft only');
            showHint(msg);
            ae('tool_error', { f: 'tiles' });
            setTimeout(function () { if (hintEl && hintEl.textContent === msg) showHint(''); }, 4000);
        }

        if (window.__mapTiles) {
            // Яркость — по теме сайта на момент загрузки, как было: палитра
            // бортов подобрана под неё и не перекрашивается на лету.
            window.__mapTiles.base(L, map, null, {
                slug: 'flight-tracker', style: dark ? 'dark' : 'light', credit: credit,
                opts: { maxZoom: 19 }, onExhausted: tilesGone
            });
        } else if (window.__basemapFallback) {
            window.__basemapFallback(L, map, credit);
        }

        // ── State ──────────────────────────────────────────────────────────
        var planes = {}, order = [], routes = {}, photos = {};
        var selected = null, following = false, showGround = false;
        var altFilter = 'all', militaryOnly = false, oceanOnly = false;
        var landmask = null, landmaskLoading = false;
        var watch = null; // { q, timer }
        var lastFetch = 0, firstData = false, hovered = null, dragging = false, lastFollowRecenter = 0;

        function sizeCanvas() {
            var dpr = window.devicePixelRatio || 1;
            var w = stage.clientWidth, h = stage.clientHeight;
            canvas.width = Math.round(w * dpr); canvas.height = Math.round(h * dpr);
            canvas.style.width = w + 'px'; canvas.style.height = h + 'px';
            ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        }

        // ── Altitude → colour ──────────────────────────────────────────────
        var STOPS = [[0, [248, 113, 113]], [10000, [251, 191, 36]], [20000, [74, 222, 128]], [30000, [56, 189, 248]], [40000, [129, 140, 248]]];
        function altColor(alt, ground) {
            if (ground) { return '#9aa7bd'; }
            if (alt == null) { return '#7aa7ff'; }
            var a = Math.max(0, Math.min(40000, alt));
            for (var i = 1; i < STOPS.length; i++) {
                if (a <= STOPS[i][0]) {
                    var lo = STOPS[i - 1], hi = STOPS[i], f = (a - lo[0]) / (hi[0] - lo[0] || 1);
                    return 'rgb(' + Math.round(lo[1][0] + (hi[1][0] - lo[1][0]) * f) + ',' + Math.round(lo[1][1] + (hi[1][1] - lo[1][1]) * f) + ',' + Math.round(lo[1][2] + (hi[1][2] - lo[1][2]) * f) + ')';
                }
            }
            return '#818cf8';
        }

        // ── Land/ocean mask (lazy) ─────────────────────────────────────────
        function loadLandmask() {
            if (landmask || landmaskLoading || !CFG.landmask) { return; }
            landmaskLoading = true;
            fetch(CFG.landmask, { headers: { 'Accept': 'application/json' } })
                .then(function (r) { return r.json(); })
                .then(function (m) {
                    var bin = atob(m.data), bytes = new Uint8Array(bin.length);
                    for (var i = 0; i < bin.length; i++) { bytes[i] = bin.charCodeAt(i); }
                    landmask = { w: m.w, h: m.h, bytes: bytes };
                    for (var k = 0; k < order.length; k++) { var p = planes[order[k]]; if (p) { p.ocean = !isLand(p.la, p.lo); } }
                    refreshCount();
                })
                .catch(function () { landmaskLoading = false; });
        }
        function isLand(lat, lon) {
            if (!landmask) { return true; }
            var col = Math.floor((lon + 180) / (360 / landmask.w));
            var row = Math.floor((90 - lat) / (180 / landmask.h));
            if (col < 0 || col >= landmask.w || row < 0 || row >= landmask.h) { return false; }
            var idx = row * landmask.w + col;
            return (landmask.bytes[idx >> 3] >> (idx & 7)) & 1;
        }

        // ── Filter predicate ───────────────────────────────────────────────
        function passFilter(p) {
            if (p.gd) { return showGround && !militaryOnly && !oceanOnly; }
            if (militaryOnly && !(p.df & 1)) { return false; }
            if (oceanOnly && !p.ocean) { return false; }
            var a = p.al == null ? 0 : p.al;
            if (altFilter === 'low') { return a < 10000; }
            if (altFilter === 'mid') { return a >= 10000 && a < 30000; }
            if (altFilter === 'high') { return a >= 30000; }
            return true;
        }

        function project(lat, lon, trackDeg, speedKt, dtSec) {
            if (!speedKt || trackDeg == null) { return [lat, lon]; }
            var distDeg = (speedKt * dtSec / 3600) / 60, rad = trackDeg * Math.PI / 180, cosL = Math.cos(lat * Math.PI / 180);
            return [lat + distDeg * Math.cos(rad), lon + (Math.abs(cosL) > 1e-6 ? distDeg * Math.sin(rad) / cosL : 0)];
        }

        // ── Merge a server batch ───────────────────────────────────────────
        function merge(list, now) {
            for (var i = 0; i < list.length; i++) {
                var a = list[i];
                if (!a || !a.h) { continue; }
                var p = planes[a.h];
                if (!p) { p = planes[a.h] = { h: a.h, dla: a.la, dlo: a.lo, trail: [] }; order.push(a.h); }
                p.la = a.la; p.lo = a.lo; p.t0 = now;
                p.tk = a.tk; p.sp = a.sp; p.al = a.al; p.gd = a.gd; p.vr = a.vr;
                p.c = a.c; p.rg = a.rg; p.ty = a.ty; p.ds = a.ds; p.ai = a.ai; p.ia = a.ia;
                p.sq = a.sq; p.ct = a.ct; p.ag = a.ag; p.df = a.df || 0;
                p.ocean = landmask ? !isLand(a.la, a.lo) : false;
                p.seen = now;
                if (p.dla == null) { p.dla = a.la; p.dlo = a.lo; }
            }
            var keep = [];
            for (var j = 0; j < order.length; j++) {
                var h = order[j], q = planes[h];
                if (q && (now - q.seen) <= DROP_AFTER) { keep.push(h); }
                else { delete planes[h]; if (selected === h) { closeCard(); } }
            }
            order = keep;
            if (selected && planes[selected]) {
                var s = planes[selected];
                s.trail.push([s.la, s.lo]);
                if (s.trail.length > 260) { s.trail.shift(); }
                if (cardEl && !cardEl.classList.contains('hidden')) { renderCard(); }
            }
        }

        // ── Drawing ────────────────────────────────────────────────────────
        function planePath(c) {
            c.beginPath(); c.moveTo(0, -10);
            c.lineTo(1.7, -3.2); c.lineTo(9, 2.2); c.lineTo(9, 4.2);
            c.lineTo(1.7, 1.6); c.lineTo(1.5, 7); c.lineTo(3.6, 9);
            c.lineTo(3.6, 10.4); c.lineTo(0, 9.2);
            c.lineTo(-3.6, 10.4); c.lineTo(-3.6, 9); c.lineTo(-1.5, 7);
            c.lineTo(-1.7, 1.6); c.lineTo(-9, 4.2); c.lineTo(-9, 2.2);
            c.lineTo(-1.7, -3.2); c.closePath();
        }
        function airportDot(p, label, col) {
            ctx.save();
            ctx.beginPath(); ctx.arc(p.x, p.y, 4, 0, Math.PI * 2);
            ctx.fillStyle = col; ctx.fill();
            ctx.strokeStyle = 'rgba(255,255,255,0.85)'; ctx.lineWidth = 1.4; ctx.stroke();
            if (label) {
                ctx.font = '600 11px system-ui,sans-serif'; ctx.fillStyle = '#eaf1ff';
                ctx.strokeStyle = 'rgba(4,8,16,0.85)'; ctx.lineWidth = 3; ctx.textAlign = 'center';
                ctx.strokeText(label, p.x, p.y - 9); ctx.fillText(label, p.x, p.y - 9);
            }
            ctx.restore();
        }

        function draw() {
            var now = Date.now();
            var w = stage.clientWidth, h = stage.clientHeight;
            ctx.clearRect(0, 0, w, h);
            var z = map.getZoom();
            var scale = z >= 9 ? 1.05 : (z >= 7 ? 0.92 : (z >= 5 ? 0.8 : 0.66));
            var sp = selected && planes[selected];

            if (sp && sp.route && sp.route.from && sp.route.to) {
                var pPlane = map.latLngToContainerPoint([sp.dla, sp.dlo]);
                var pFrom = map.latLngToContainerPoint([sp.route.from.lat, sp.route.from.lon]);
                var pTo = map.latLngToContainerPoint([sp.route.to.lat, sp.route.to.lon]);
                ctx.save();
                ctx.lineWidth = 2; ctx.strokeStyle = 'rgba(120,180,255,0.5)';
                ctx.setLineDash([]); ctx.beginPath(); ctx.moveTo(pFrom.x, pFrom.y); ctx.lineTo(pPlane.x, pPlane.y); ctx.stroke();
                ctx.setLineDash([6, 6]); ctx.strokeStyle = 'rgba(120,180,255,0.32)'; ctx.beginPath(); ctx.moveTo(pPlane.x, pPlane.y); ctx.lineTo(pTo.x, pTo.y); ctx.stroke();
                ctx.setLineDash([]); ctx.restore();
                airportDot(pFrom, sp.route.from.iata || sp.route.from.icao, '#5fd0a0');
                airportDot(pTo, sp.route.to.iata || sp.route.to.icao, '#f0a868');
            }

            if (sp && sp.trail.length > 1) {
                ctx.lineWidth = 2; ctx.strokeStyle = 'rgba(120,180,255,0.55)';
                ctx.beginPath();
                for (var ti = 0; ti < sp.trail.length; ti++) {
                    var tpt = map.latLngToContainerPoint(sp.trail[ti]);
                    ti === 0 ? ctx.moveTo(tpt.x, tpt.y) : ctx.lineTo(tpt.x, tpt.y);
                }
                ctx.stroke();
            }

            for (var i = 0; i < order.length; i++) {
                var p = planes[order[i]];
                if (!p) { continue; }
                if (!passFilter(p)) { p.screen = null; continue; }
                var dt = (now - p.t0) / 1000;
                var target = (p.gd || !p.sp) ? [p.la, p.lo] : project(p.la, p.lo, p.tk, p.sp, dt);
                p.dla += (target[0] - p.dla) * 0.16;
                p.dlo += (target[1] - p.dlo) * 0.16;
                var pt = map.latLngToContainerPoint([p.dla, p.dlo]);
                p.screen = pt;
                if (pt.x < -20 || pt.y < -20 || pt.x > w + 20 || pt.y > h + 20) { continue; }
                var isSel = selected === order[i], isHov = hovered === order[i];
                var emerg = p.sq && EMERG[p.sq];
                var col = emerg ? '#ff5a5a' : altColor(p.al, p.gd);
                ctx.save();
                ctx.translate(pt.x, pt.y); ctx.rotate((p.tk || 0) * Math.PI / 180); ctx.scale(scale, scale);
                if (isSel || emerg) { ctx.shadowColor = emerg ? 'rgba(255,80,80,0.95)' : 'rgba(120,180,255,0.9)'; ctx.shadowBlur = 14; }
                planePath(ctx);
                ctx.fillStyle = isSel ? '#ffffff' : col; ctx.fill();
                ctx.shadowBlur = 0;
                ctx.lineWidth = isSel ? 1.6 : 0.8; ctx.strokeStyle = isSel ? col : 'rgba(4,8,16,0.7)'; ctx.stroke();
                ctx.restore();
                if (isSel || isHov || emerg) {
                    ctx.beginPath(); ctx.arc(pt.x, pt.y, 15 * scale, 0, Math.PI * 2);
                    ctx.strokeStyle = emerg ? 'rgba(255,90,90,0.85)' : (isSel ? 'rgba(255,255,255,0.85)' : 'rgba(160,190,240,0.6)');
                    ctx.lineWidth = 1.4; ctx.stroke();
                }
            }

            if (following && sp && !dragging && (now - lastFollowRecenter) > 700) {
                var fpt = map.latLngToContainerPoint([sp.dla, sp.dlo]);
                if (Math.abs(fpt.x - w / 2) > w * 0.28 || Math.abs(fpt.y - h / 2) > h * 0.28) {
                    map.panTo([sp.dla, sp.dlo], { animate: true, duration: 0.6 }); lastFollowRecenter = now;
                }
            }
            raf = requestAnimationFrame(draw);
        }
        var raf = requestAnimationFrame(draw);

        // ── Status / hints / stats ─────────────────────────────────────────
        function setStatus(text, stale) { statusText.textContent = text; if (dotEl) { dotEl.classList.toggle('stale', !!stale); } }
        function showHint(text) { if (!hintEl) { return; } if (text) { hintEl.textContent = text; hintEl.classList.add('show'); } else { hintEl.classList.remove('show'); } }
        function visibleCount() { var n = 0; for (var i = 0; i < order.length; i++) { var p = planes[order[i]]; if (p && passFilter(p)) { n++; } } return n; }
        function refreshCount() { if (firstData) { setStatus(fmt(tr('aircraft_n', ':n aircraft'), { n: visibleCount() })); updateStats(); } }
        function updateStats() {
            if (!statsEl) { return; }
            var hi = null, fa = null;
            for (var i = 0; i < order.length; i++) {
                var p = planes[order[i]];
                if (!p || !passFilter(p) || p.gd) { continue; }
                if (p.al != null && (!hi || p.al > hi.al)) { hi = p; }
                if (p.sp != null && (!fa || p.sp > fa.sp)) { fa = p; }
            }
            var parts = '';
            if (hi) { parts += '<button type="button" class="ft-stat" data-hex="' + esc(hi.h) + '" title="' + esc(tr('stats_highest', 'Highest')) + '">▲ ' + esc(hi.c || hi.rg || '') + ' <b>' + hi.al.toLocaleString() + '</b> ' + tr('u_ft', 'ft') + '</button>'; }
            if (fa) { parts += '<button type="button" class="ft-stat" data-hex="' + esc(fa.h) + '" title="' + esc(tr('stats_fastest', 'Fastest')) + '">⚡ ' + esc(fa.c || fa.rg || '') + ' <b>' + fa.sp.toLocaleString() + '</b> ' + tr('u_kt', 'kt') + '</button>'; }
            statsEl.innerHTML = parts;
            statsEl.style.display = parts ? '' : 'none';
            var btns = statsEl.querySelectorAll('.ft-stat');
            for (var k = 0; k < btns.length; k++) {
                btns[k].addEventListener('click', function () { var hx = this.getAttribute('data-hex'); if (planes[hx]) { map.setView([planes[hx].dla, planes[hx].dlo], Math.max(7, map.getZoom()), { animate: true }); select(hx); } });
            }
        }

        // ── Fetch area ─────────────────────────────────────────────────────
        function radiusNm() { var b = map.getBounds(), c = map.getCenter(); return Math.max(30, Math.min(250, Math.round(c.distanceTo(b.getNorthEast()) / 1852))); }
        function fetchArea(force) {
            var now = Date.now();
            if (!force && (now - lastFetch) < MIN_FETCH_GAP) { return; }
            lastFetch = now;
            var c = map.getCenter();
            fetch(CFG.api.area + '?lat=' + c.lat.toFixed(4) + '&lon=' + c.lng.toFixed(4) + '&radius=' + radiusNm(), { headers: { 'Accept': 'application/json' } })
                .then(function (r) { return r.json(); })
                .then(function (d) {
                    merge((d && d.ac) || [], Date.now());
                    if (!firstData) { firstData = true; loadingEl.classList.add('hidden'); ae('feature_use', { f: 'map_loaded', n: visibleCount() }); }
                    var n = visibleCount();
                    setStatus(fmt(tr('aircraft_n', ':n aircraft'), { n: n }), d && d.stale);
                    updateStats();
                    if (map.getZoom() <= 4) { showHint(tr('zoom_in_hint', 'Zoom in to load aircraft in view')); }
                    else if (n === 0) { showHint(tr('no_planes', 'No tracked aircraft here right now')); }
                    else if (!tileWarned) { showHint(''); }
                })
                .catch(function () { if (!firstData) { setStatus(tr('no_planes', 'No data'), true); ae('tool_error', { f: 'area' }); } });
        }

        // ── Route / photo / trace lookups ──────────────────────────────────
        function fetchRoute(cs) {
            if (!cs || !CFG.api.route) { return; }
            if (routes[cs] !== undefined) { if (selected && planes[selected] && planes[selected].c === cs) { planes[selected].route = routes[cs] || null; renderCard(); } return; }
            fetch(CFG.api.route + '?cs=' + encodeURIComponent(cs), { headers: { 'Accept': 'application/json' } })
                .then(function (r) { return r.json(); })
                .then(function (d) {
                    var rt = (d && d.from && d.to) ? d : false; routes[cs] = rt;
                    if (selected && planes[selected] && planes[selected].c === cs) { planes[selected].route = rt || null; renderCard(); if (rt) { ae('feature_use', { f: 'route' }); } }
                })
                .catch(function () { routes[cs] = false; });
        }
        function fetchPhoto(hex) {
            if (!hex || !CFG.api.photo) { return; }
            if (photos[hex] !== undefined) { if (selected === hex) { renderCard(); } return; }
            fetch(CFG.api.photo + '?hex=' + encodeURIComponent(hex), { headers: { 'Accept': 'application/json' } })
                .then(function (r) { return r.json(); })
                .then(function (d) {
                    photos[hex] = (d && d.img) ? d : false;
                    if (selected === hex) { renderCard(); if (photos[hex]) { ae('feature_use', { f: 'photo' }); } }
                })
                .catch(function () { photos[hex] = false; });
        }
        function fetchTrace(hex) {
            if (!hex || !CFG.api.trace) { return; }
            fetch(CFG.api.trace + '?hex=' + encodeURIComponent(hex), { headers: { 'Accept': 'application/json' } })
                .then(function (r) { return r.json(); })
                .then(function (d) {
                    if (selected === hex && planes[hex] && d && d.pts && d.pts.length > 1) {
                        planes[hex].trail = d.pts.map(function (q) { return [q[0], q[1]]; });
                        ae('feature_use', { f: 'history' });
                    }
                })
                .catch(function () {});
        }

        // ── Search + watch-for-takeoff ─────────────────────────────────────
        var searchForm = document.getElementById('ftSearchForm');
        var searchInput = document.getElementById('ftSearch');
        var searchBtn = document.getElementById('ftSearchBtn');
        function runSearch(q) {
            q = (q || '').trim().toUpperCase();
            if (q.length < 2) { return; }
            searchBtn.disabled = true; var prev = searchBtn.textContent; searchBtn.textContent = tr('searching', '…');
            fetch(CFG.api.search + '?q=' + encodeURIComponent(q), { headers: { 'Accept': 'application/json' } })
                .then(function (r) { return r.json(); })
                .then(function (d) {
                    var list = (d && d.ac) || [];
                    if (list.length) {
                        var a = list[0]; merge([a], Date.now());
                        map.setView([a.la, a.lo], Math.max(8, map.getZoom()), { animate: true });
                        select(a.h, true); following = true; renderCard();
                        complete('search'); clearWatchUI();
                        setTimeout(function () { fetchArea(true); }, 400);
                    } else {
                        ae('feature_use', { f: 'search', found: 0 });
                        offerWatch(q);
                    }
                })
                .catch(function () { toast(tr('search_none', 'Flight not found'), 'warning'); ae('tool_error', { f: 'search' }); })
                .finally(function () { searchBtn.disabled = false; searchBtn.textContent = prev; });
        }
        if (searchForm) { searchForm.addEventListener('submit', function (e) { e.preventDefault(); runSearch(searchInput.value); }); }

        // Подстановка из URL: ?flight=SU0731. Сюда приводит роутер поиска —
        // человек набрал номер рейса в поисковой строке сайта, и приземлиться
        // он должен на РЕЗУЛЬТАТ, а не на пустую форму (тот же контракт, что у
        // /whois-lookup и /dns-lookup с ?domain=).
        try {
            var _pf = new URLSearchParams(location.search).get('flight');
            if (_pf && searchInput) {
                searchInput.value = _pf.trim().toUpperCase().slice(0, 10);
                runSearch(searchInput.value);
            }
        } catch (e) {}

        /**
         * Пустой ответ поиска — и объяснение, почему он пустой.
         *
         * Замер 14.08 за 30 дней: 8711 поисков вернули 0 бортов против 115
         * удачных, то есть находит рейс 2.7% сессий. Текст при этом утверждал
         * «рейс сейчас не в воздухе» — а он чаще всего летит: над Москвой в
         * радиусе 250 км трекер видит ОДИН борт, над Франкфуртом в радиусе
         * 150 км — 38. У OpenSky ровно тот же единственный борт, значит дело
         * не в выборе провайдера, а в отсутствии наземных приёмников. Строка
         * `coverage_note` для этого и лежала в переводах всех девяти локалей —
         * и не показывалась НИГДЕ: её выгружали на страницу и ни разу не
         * читали. Теперь она стоит там, где человек задал вопрос.
         */
        function offerWatch(q) {
            if (!watchEl) { toast(tr('search_none', 'Flight not visible right now'), 'warning'); return; }
            watchEl.innerHTML = '<span class="ft-watch-msg">' + fmt(tr('not_airborne', '":q" is not visible right now'), { q: esc(q) }) + '</span>' +
                '<span class="ft-watch-why">' + esc(tr('coverage_note', '')) + '</span>' +
                '<button type="button" class="ft-watch-btn" id="ftWatchGo">' + esc(tr('watch_takeoff', 'Notify me when it shows up')) + '</button>';
            watchEl.classList.add('show');
            var go = document.getElementById('ftWatchGo');
            if (go) { go.addEventListener('click', function () { startWatch(q); }); }
        }
        function startWatch(q) {
            stopWatch();
            requestNotify();
            watch = { q: q };
            watch.timer = setInterval(function () { pollWatch(q); }, 60000);
            if (watchEl) {
                watchEl.innerHTML = '<span class="ft-watch-msg on">' + fmt(tr('watching', 'Watching ":q" — we\'ll alert you when it\'s airborne'), { q: esc(q) }) + '</span>' +
                    '<button type="button" class="ft-watch-btn ghost" id="ftWatchStop">' + esc(tr('stop_watch', 'Stop')) + '</button>';
                var st = document.getElementById('ftWatchStop'); if (st) { st.addEventListener('click', stopWatch); }
            }
            ae('feature_use', { f: 'watch_start' });
        }
        function pollWatch(q) {
            fetch(CFG.api.search + '?q=' + encodeURIComponent(q), { headers: { 'Accept': 'application/json' } })
                .then(function (r) { return r.json(); })
                .then(function (d) {
                    var list = (d && d.ac) || [];
                    if (list.length) {
                        var a = list[0]; beep();
                        notify(fmt(tr('took_off', '":q" has taken off'), { q: q }), (a.ai || '') + (a.al ? ' · ' + a.al.toLocaleString() + ' ' + tr('u_ft', 'ft') : ''));
                        toast(fmt(tr('took_off', '":q" has taken off'), { q: q }), 'success');
                        stopWatch();
                        merge([a], Date.now()); map.setView([a.la, a.lo], Math.max(8, map.getZoom()), { animate: true });
                        select(a.h, true); following = true; renderCard();
                        ae('feature_use', { f: 'watch_hit' });
                    }
                })
                .catch(function () {});
        }
        function stopWatch() { if (watch && watch.timer) { clearInterval(watch.timer); } watch = null; clearWatchUI(); }
        function clearWatchUI() { if (watchEl) { watchEl.classList.remove('show'); watchEl.innerHTML = ''; } }

        function beep() {
            try {
                var AC = window.AudioContext || window.webkitAudioContext; if (!AC) { return; }
                var ac = new AC(), g = ac.createGain(); g.connect(ac.destination);
                g.gain.setValueAtTime(0.0001, ac.currentTime);
                g.gain.exponentialRampToValueAtTime(0.3, ac.currentTime + 0.02);
                g.gain.exponentialRampToValueAtTime(0.0001, ac.currentTime + 0.6);
                var o = ac.createOscillator(); o.type = 'sine'; o.frequency.setValueAtTime(880, ac.currentTime); o.frequency.setValueAtTime(1175, ac.currentTime + 0.2);
                o.connect(g); o.start(); o.stop(ac.currentTime + 0.6);
            } catch (e) {}
        }
        function requestNotify() { try { if (window.Notification && Notification.permission === 'default') { Notification.requestPermission(); } } catch (e) {} }
        function notify(title, body) { try { if (window.Notification && Notification.permission === 'granted') { new Notification(title, { body: body }); } } catch (e) {} }

        // ── Geolocate ──────────────────────────────────────────────────────
        var locateBtn = document.getElementById('ftLocate');
        if (locateBtn) {
            locateBtn.addEventListener('click', function () {
                // See earth-globe: absent API means a flipped pref, not an old browser.
                if (!navigator.geolocation) { if (window.__geo) __geo.notify('no_api'); return; }
                var span = locateBtn.querySelector('span'), prev = span ? span.textContent : '';
                if (span) { span.textContent = tr('locating', 'Locating…'); }
                navigator.geolocation.getCurrentPosition(function (pos) {
                    if (span) { span.textContent = prev; }
                    map.setView([pos.coords.latitude, pos.coords.longitude], 8, { animate: true });
                    fetchArea(true); ae('feature_use', { f: 'geolocate' });
                }, function (err) {
                    if (span) { span.textContent = prev; }
                    if (window.__geo) __geo.notify(err);
                }, { enableHighAccuracy: false, timeout: 8000, maximumAge: 60000 });
            });
        }

        // ── Toggles & filters ──────────────────────────────────────────────
        if (groundChk) {
            try { if (window.__toolSettings) { window.__toolSettings.bind('flight-tracker', groundChk, 'show_ground', false); } } catch (e) {}
            showGround = groundChk.checked;
            groundChk.addEventListener('change', function () { showGround = groundChk.checked; refreshCount(); });
        }
        var filterBtns = document.querySelectorAll('.ft-filter [data-alt]');
        for (var fi = 0; fi < filterBtns.length; fi++) {
            filterBtns[fi].addEventListener('click', function () {
                altFilter = this.getAttribute('data-alt');
                for (var k = 0; k < filterBtns.length; k++) { filterBtns[k].classList.toggle('active', filterBtns[k] === this); }
                refreshCount(); ae('feature_use', { f: 'alt_filter', v: altFilter });
            });
        }
        var milChip = document.getElementById('ftMil');
        if (milChip) {
            milChip.addEventListener('click', function () { militaryOnly = !militaryOnly; milChip.classList.toggle('active', militaryOnly); refreshCount(); ae('feature_use', { f: 'mil_filter', v: militaryOnly ? 1 : 0 }); });
        }
        var oceanChip = document.getElementById('ftOcean');
        if (oceanChip) {
            oceanChip.addEventListener('click', function () {
                oceanOnly = !oceanOnly; oceanChip.classList.toggle('active', oceanOnly);
                if (oceanOnly) { loadLandmask(); }
                for (var k = 0; k < order.length; k++) { var p = planes[order[k]]; if (p) { p.ocean = landmask ? !isLand(p.la, p.lo) : false; } }
                refreshCount(); ae('feature_use', { f: 'ocean_filter', v: oceanOnly ? 1 : 0 });
            });
        }

        // ── Fullscreen ─────────────────────────────────────────────────────
        // Native first via the shared __safeFullscreen (the raw
        // stage.requestFullscreen() promise REJECTS with "TypeError:
        // Fullscreen is not supported" in Android WebViews whose host app
        // never implemented onShowCustomView — TIMBRICA-FRONTEND-CR — and
        // the method does not exist at all on iPhone Safari). Both of those
        // fall back to CSS pseudo-fullscreen: same button, the map really
        // fills the viewport, second click / Escape exits.
        var fsBtn = document.getElementById('ftFs');
        var fakeFs = false;
        function setFakeFs(on) {
            fakeFs = on;
            stage.classList.toggle('ft-fake-fs', on);
            document.documentElement.classList.toggle('ft-fake-fs-lock', on);
            setTimeout(function () { sizeCanvas(); map.invalidateSize(); }, 80);
        }
        if (fsBtn) {
            fsBtn.addEventListener('click', function () {
                if (fakeFs) { setFakeFs(false); return; }
                if (document.fullscreenElement) { document.exitFullscreen(); return; }
                ae('feature_use', { f: 'fullscreen' });
                if (window.__safeFullscreen) {
                    window.__safeFullscreen(stage, {
                        onDenied: function () { setFakeFs(true); },
                        onUnsupported: function () { setFakeFs(true); },
                    });
                } else if (stage.requestFullscreen) {
                    // Core script missing (blocked) — old behaviour, but keep
                    // the rejection from surfacing as an unhandled error.
                    stage.requestFullscreen().catch(function () { setFakeFs(true); });
                } else {
                    setFakeFs(true);
                }
            });
            document.addEventListener('fullscreenchange', function () { setTimeout(function () { sizeCanvas(); map.invalidateSize(); }, 80); });
            document.addEventListener('keydown', function (e) {
                if (e.key === 'Escape' && fakeFs) { setFakeFs(false); }
            });
        }

        // ── Selection / card ───────────────────────────────────────────────
        function select(hex, fromSearch) {
            selected = hex;
            var p = planes[hex];
            if (p) {
                p.trail = [[p.dla, p.dlo]];
                p.route = (p.c && routes[p.c]) ? routes[p.c] : (p.route || null);
                if (p.c) { fetchRoute(p.c); }
                fetchPhoto(hex); fetchTrace(hex);
                try { history.replaceState(null, '', '#' + (p.c || p.rg || hex)); } catch (e) {}
            }
            renderCard();
            if (!fromSearch) { complete('select'); }
        }
        function closeCard() {
            selected = null; following = false;
            cardEl.classList.add('hidden');
            try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
        }
        function vrInfo(vr) {
            if (vr == null) { return { cls: 'level', label: tr('level', 'Level'), arrow: '' }; }
            if (vr > 130) { return { cls: 'up', label: tr('climbing', 'Climbing'), arrow: 'M12 19V5M5 12l7-7 7 7' }; }
            if (vr < -130) { return { cls: 'down', label: tr('descending', 'Descending'), arrow: 'M12 5v14M5 12l7 7 7-7' }; }
            return { cls: 'level', label: tr('level', 'Level'), arrow: '' };
        }
        function row(k, v) { return '<div class="ft-row"><span class="k">' + esc(k) + '</span><span class="v">' + v + '</span></div>'; }
        function apLabel(a) { return esc((a.iata || a.icao || '') + (a.city || a.name ? ' · ' + (a.city || a.name) : '')); }

        function renderCard() {
            var p = selected && planes[selected];
            if (!p) { cardEl.classList.add('hidden'); return; }
            var unk = tr('unknown', '—');
            var title = p.c || p.rg || p.h.toUpperCase();
            var emerg = p.sq && EMERG[p.sq];
            var alt = p.gd ? tr('on_ground', 'On ground')
                : (p.al != null ? esc(p.al.toLocaleString()) + ' <small>' + tr('u_ft', 'ft') + ' · ' + Math.round(p.al * 0.3048).toLocaleString() + ' ' + tr('u_m', 'm') + '</small>' : unk);
            var spd = p.sp != null ? esc(p.sp) + ' <small>' + tr('u_kt', 'kt') + ' · ' + Math.round(p.sp * 1.852) + ' ' + tr('u_kmh', 'km/h') + '</small>' : unk;
            var hdg = p.tk != null ? esc(Math.round(p.tk)) + '°' : unk;
            var v = vrInfo(p.vr);
            var vrHtml = '<span class="ft-vr ' + v.cls + '">' + (v.arrow ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="' + v.arrow + '"/></svg>' : '') + esc(v.label) + (p.vr != null && p.vr !== 0 ? ' <small>' + Math.abs(p.vr).toLocaleString() + ' ' + tr('u_fpm', 'ft/min') + '</small>' : '') + '</span>';

            var logoHtml = (p.ia && CFG.api.logo) ? '<img class="ft-logo" src="' + esc(CFG.api.logo + '?ia=' + p.ia) + '" alt="" onerror="this.style.display=\'none\'">' : '';
            var routeHtml = '';
            if (p.route && p.route.from && p.route.to) {
                routeHtml = '<div class="ft-route"><span class="ft-ap from">' + apLabel(p.route.from) + '</span><svg class="ft-rarrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg><span class="ft-ap to">' + apLabel(p.route.to) + '</span></div>';
            }
            var ph = photos[p.h];
            var photoHtml = '';
            if (ph && ph.img) {
                photoHtml = '<div class="ft-photo"><a href="' + esc(ph.link || '#') + '" target="_blank" rel="noopener nofollow"><img src="' + esc(ph.img) + '" alt="" loading="lazy"></a>' +
                    (ph.photographer ? '<span class="ft-photo-by">© ' + esc(ph.photographer) + ' · airport-data.com</span>' : '') + '</div>';
            }

            var html = '' +
                '<div class="ft-card-head' + (emerg ? ' emerg' : '') + '">' +
                    '<div class="ft-card-id">' + logoHtml + '<div><div class="ft-card-cs">' + esc(title) + (emerg ? ' <span class="ft-emerg">' + esc(tr('emergency', 'Emergency')) + '</span>' : '') + '</div>' +
                    (p.ai ? '<div class="ft-card-air">' + esc(p.ai) + '</div>' : '') + '</div></div>' +
                    '<button type="button" class="ft-card-x" id="ftCardX" aria-label="' + esc(tr('close', 'Close')) + '">&times;</button>' +
                '</div>' +
                photoHtml + routeHtml +
                '<div class="ft-card-body">' +
                    (p.ds || p.ty ? row(tr('aircraft_type', 'Aircraft'), esc(p.ds || p.ty)) : '') +
                    (p.rg ? row(tr('registration', 'Registration'), esc(p.rg)) : '') +
                    row(tr('altitude', 'Altitude'), alt) +
                    row(tr('speed', 'Speed'), spd) +
                    row(tr('heading', 'Heading'), hdg) +
                    row(tr('vertical_rate', 'Vertical rate'), vrHtml) +
                    (p.sq ? row(tr('squawk', 'Squawk'), esc(p.sq)) : '') +
                    (p.ag != null ? row(tr('position_age', 'Position age'), fmt(tr('seconds_ago', ':n s ago'), { n: Math.round(p.ag) })) : '') +
                '</div>' +
                '<div class="ft-card-foot">' +
                    '<button type="button" class="ft-follow' + (following ? ' on' : '') + '" id="ftFollow">' +
                        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"/><circle cx="12" cy="12" r="9"/></svg>' +
                        '<span>' + esc(following ? tr('following', 'Following') : tr('follow', 'Follow')) + '</span>' +
                    '</button>' +
                    '<button type="button" class="ft-share" id="ftShare" title="' + esc(tr('share', 'Share flight')) + '" aria-label="' + esc(tr('share', 'Share flight')) + '">' +
                        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="M8.6 13.5l6.8 4M15.4 6.5l-6.8 4"/></svg>' +
                    '</button>' +
                '</div>';
            cardEl.innerHTML = html;
            cardEl.classList.remove('hidden');
            var x = document.getElementById('ftCardX'); if (x) { x.addEventListener('click', closeCard); }
            var f = document.getElementById('ftFollow');
            if (f) { f.addEventListener('click', function () { following = !following; if (following && planes[selected]) { map.panTo([planes[selected].dla, planes[selected].dlo], { animate: true }); ae('feature_use', { f: 'follow' }); } renderCard(); }); }
            var sh = document.getElementById('ftShare'); if (sh) { sh.addEventListener('click', shareFlight); }
        }

        function shareFlight() {
            var p = selected && planes[selected]; if (!p) { return; }
            var url = location.origin + location.pathname + '#' + (p.c || p.rg || p.h);
            var done = function () { toast(tr('link_copied', 'Link copied'), 'success'); ae('feature_use', { f: 'share' }); };
            if (navigator.share) { navigator.share({ title: (p.c || '') + ' — ' + tr('title', 'Flight Tracker'), url: url }).then(function () { ae('feature_use', { f: 'share' }); }).catch(function () {}); }
            else if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(url).then(done).catch(function () { toast(url, 'info'); }); }
            else { toast(url, 'info'); }
        }

        // ── Pointer interaction ────────────────────────────────────────────
        function pick(cx, cy) {
            var best = null, bd = HIT_PX * HIT_PX;
            for (var i = 0; i < order.length; i++) {
                var p = planes[order[i]];
                if (!p || !p.screen) { continue; }
                var dx = p.screen.x - cx, dy = p.screen.y - cy, d = dx * dx + dy * dy;
                if (d < bd) { bd = d; best = order[i]; }
            }
            return best;
        }
        map.on('mousemove', function (e) {
            var cp = e.containerPoint, hit = pick(cp.x, cp.y);
            hovered = hit;
            var container = map.getContainer();
            if (hit) {
                container.style.cursor = 'pointer';
                var p = planes[hit];
                tipEl.innerHTML = '<b>' + esc(p.c || p.rg || hit.toUpperCase()) + '</b><small>' + (p.gd ? tr('on_ground', 'On ground') : (p.al != null ? esc(p.al.toLocaleString()) + ' ' + tr('u_ft', 'ft') : '')) + '</small>';
                tipEl.style.left = p.screen.x + 'px'; tipEl.style.top = p.screen.y + 'px'; tipEl.classList.remove('hidden');
            } else { container.style.cursor = ''; tipEl.classList.add('hidden'); }
        });
        map.on('click', function (e) { var hit = pick(e.containerPoint.x, e.containerPoint.y); if (hit) { select(hit); } else { closeCard(); } });
        map.on('mouseout', function () { hovered = null; tipEl.classList.add('hidden'); });

        var moveTimer = null;
        map.on('moveend zoomend', function () { clearTimeout(moveTimer); moveTimer = setTimeout(function () { fetchArea(false); }, 450); });
        map.on('dragstart', function () { dragging = true; if (following) { following = false; renderCard(); } });
        map.on('dragend', function () { dragging = false; });
        map.on('resize', function () { sizeCanvas(); });
        window.addEventListener('resize', function () { sizeCanvas(); });

        function applyHash() {
            var hsh = (location.hash || '').replace(/^#/, '').trim();
            if (hsh && hsh.length >= 2 && hsh.length <= 12 && /^[A-Za-z0-9\-]+$/.test(hsh)) {
                if (searchInput) { searchInput.value = hsh; }
                runSearch(hsh);
            }
        }

        // ── Go ─────────────────────────────────────────────────────────────
        sizeCanvas();
        map.whenReady(function () { setTimeout(function () { map.invalidateSize(); sizeCanvas(); }, 60); });
        fetchArea(true);
        setInterval(function () { fetchArea(true); }, POLL_MS);
        setTimeout(applyHash, 700);

        try { if (window.Timbrica3D && typeof window.Timbrica3D.init === 'function') { window.Timbrica3D.init('flight-tracker'); } } catch (e) {}
    }

    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
    else { boot(); }
})();
